export interface ProgramSection {
  title: string;
  description: string;
  targets: string[];
}

export interface ProgramDetailData {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  sections: ProgramSection[];
  stats: {
    label: string;
    value: string;
  }[];
}

export const programDetailData: ProgramDetailData[] = [
  {
    slug: "kebutuhan-dasar",
    title: "Kebutuhan Dasar",
    subtitle: "Pemenuhan Hak Dasar Rumah Tangga Miskin",
    description: "Program ini berfokus pada pemenuhan kebutuhan dasar masyarakat miskin dan rentan sebagai fondasi utama peningkatan kualitas hidup dan kesejahteraan sosial.",
    sections: [
      {
        title: "Tujuan Program",
        description: "Membantu pemenuhan kebutuhan dasar rumah tangga miskin agar mampu hidup layak dan produktif dalam jangka panjang.",
        targets: ["Pendidikan Dasar", "Sekolah Rakyat", "Pangan", "Kesehatan"],
      },
      {
        title: "Instrumen Penetapan Sasaran",
        description: "DTSEN digunakan sebagai basis utama dalam penentuan penerima manfaat agar program tepat sasaran dan berdampak langsung.",
        targets: ["Data Terpadu Sosial Ekonomi Nasional (DTSEN)"],
      },
    ],
    stats: [
      { label: "Rumah Tangga Terbantu", value: "12.540+" },
      { label: "Wilayah Intervensi", value: "11 Provinsi" },
      { label: "Program Aktif", value: "15+" },
    ],
  },
  {
    slug: "produktifitas-pemberdayaan",
    title: "Produktivitas & Pemberdayaan",
    subtitle: "Peningkatan Kapasitas Pendapatan Masyarakat",
    description: "Program ini bertujuan meningkatkan kemandirian ekonomi rumah tangga miskin melalui penguatan keterampilan, usaha, dan akses pasar.",
    sections: [
      {
        title: "Tujuan Program",
        description: "Meningkatkan kapasitas pendapatan rumah tangga miskin agar mampu mandiri secara ekonomi dan berkelanjutan.",
        targets: ["Pendidikan Tinggi", "UMKM", "Koperasi & Bumdes", "Ekonomi Kreatif", "Pasar Kerja", "Pertanian", "Produk Unggulan", "Pemberdayaan PMI"],
      },
      {
        title: "Instrumen Penetapan Sasaran",
        description: "DTSEN digunakan sebagai acuan utama untuk memastikan bantuan dan pemberdayaan tepat sasaran dan berbasis kebutuhan nyata masyarakat.",
        targets: ["Data Terpadu Sosial Ekonomi Nasional (DTSEN)"],
      },
    ],
    stats: [
      { label: "Pelaku Usaha Terbantu", value: "8.200+" },
      { label: "Program Pemberdayaan", value: "15+" },
      { label: "Wilayah Implementasi", value: "11 Provinsi" },
    ],
  },

  {
    slug: "akses-layanan",
    title: "Akses Layanan Dasar",
    subtitle: "Peningkatan Kapasitas Pendapatan Masyarakat",
    description: "Program ini bertujuan meningkatkan aksesibilitas kebutuhan dasar dan fasilitas dan penunjang produktivitas di wilayah konsentrasi kelompok miskin.",
    sections: [
      {
        title: "Tujuan Program",
        description: "Meningkatkan aksesibilitas kebutuhan dasar dan fasilitas dan penunjang produktivitas di wilayah konsentrasi kelompok miskin.",
        targets: ["Fasilitas Pendidikan", "Fasilitas Kesehatan", "Komunitas & Pemberdayaan", "Infrastruktur dasar", "Penduduk Ekonomi", "Rehabilitas Rumah Tinggal"],
      },
      {
        title: "Instrumen Penetapan Sasaran",
        description: "DTSEN digunakan sebagai acuan utama untuk memastikan bantuan dan pemberdayaan tepat sasaran dan berbasis kebutuhan nyata masyarakat.",
        targets: ["Data Terpadu Sosial Ekonomi Nasional (DTSEN)"],
      },
    ],
    stats: [
      { label: "Fasilitas Terbangun / Direvitalisasi", value: "3.450+" },
      { label: "Rumah Tangga Penerima Manfaat", value: "18.200+" },
      { label: "Wilayah Intervensi", value: "11 Provinsi" },
    ],
  },
];
